import React, { FC, ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { AttributeLabel } from "../../styled";
import { CardCheckbox } from "./styled";

export const FeatureCardCheckbox: FC<{ title: ReactElement | string; checked: boolean; onChange?: VoidFunction }> = ({
  title,
  checked,
  onChange,
}) => {
  const { t } = useTranslation("featureCard");
  const label = t(checked ? "yes" : "no");

  return (
    <>
      <AttributeLabel isEdit={!!onChange} forCheckbox={!!onChange}>
        {title}
      </AttributeLabel>
      {onChange ? <CardCheckbox checked={checked} label={label} onChange={onChange} /> : label}
    </>
  );
};
